// Imports
import Pricing from './pricing';
import { Props } from './paid-plan';


// Plans
const paidPlans: Props[] = [
	{
		name: 'Inform',
		description: 'Robust features for informing your community',
		backgroundColor: 'hsl(96, 69%, 87%)',
		containerWidth: '20rem',
		accentColor: 'hsl(96, 69%, 35%)',
		pricing: (state) => <Pricing {...state} plan='inform' />,
		features: {
			label: 'Everything in free, plus:',
			features: [
				'Custom domain',
				'Resident & pet directories',
				'Visitor tracking',
				'Photo galleries',
				'FAQs',
				'Community facilities',
				'No ads',
			],
		},
		callToAction: {
			backgroundColor: 'hsl(96, 69%, 35%)',
			fontColor: 'hsl(0, 0%, 100%)',
			href: `https://start.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}`,
			text: 'Start for free',
			displayArrowIndicator: true,
		},
	},
	{
		name: 'Engage',
		description: 'All-in-one platform for engaging with your community',
		backgroundColor: 'hsl(206, 70%, 88%)',
		containerWidth: '23.75rem',
		accentColor: 'hsl(206, 69%, 35%)',
		pricing: (state) => <Pricing {...state} plan='engage' />,
		features: {
			label: 'Everything in Inform, plus:',
			features: [
				'Blast emails & texts',
				'Professional email accounts',
				'Multiple website admins',
				'Collect payments online',
				'Custom forms',
				'Surveys & polls',
				'Groups of residents',
				'Mailed letters',
			],
		},
		callToAction: {
			backgroundColor: 'hsl(206, 69%, 35%)',
			fontColor: 'hsl(0, 0%, 100%)',
			href: `https://start.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}`,
			text: 'Start for free',
			displayArrowIndicator: true,
		},
		mostPopular: {
			backgroundColor: 'hsl(206, 69%, 35%)',
			fontColor: 'hsl(0, 0%, 100%)',
		},
	},
];

const freePlan: Omit<Props, 'pricing'> = {
	name: 'Free',
	description: 'Basic features for small communities',
	backgroundColor: 'hsl(36, 100%, 90%)',
	containerWidth: '45rem',
	accentColor: 'hsl(36, 44%, 52%)',
	features: {
		features: [
			'Unlimited pages',
			'Unlimited storage',
			'Page restrictions',
			'Upload documents',
			'Calendar events',
			'Board & committee info',
			'News articles',
			'Rich text pages',
		],
	},
	callToAction: {
		backgroundColor: 'hsl(36, 44%, 52%)',
		fontColor: 'hsl(0, 0%, 100%)',
		href: `https://start.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}`,
		text: 'Get started',
		displayArrowIndicator: true,
	},
};

export { paidPlans, freePlan };
